import HttpClient from 'httpClient';
import { FlightProviderType, AllowedFlightProvidersType } from '../types';

const BASE_URL = `${process.env.REACT_APP_PACKAGE_CACHE_API || ''}/api/flightcache`;

class FlightProvidersService extends HttpClient {
  private allFlightProvidersPromise: Promise<FlightProviderType[]> | null = null;

  private allFlightProvidersCache: FlightProviderType[] | null = null;

  constructor() {
    super(BASE_URL);
  }

  public getAllFlightProvidersSettings = (): Promise<FlightProviderType[]> =>
    this.instance.get('/get/allflightproviders');

  public getAllFlightProvidersSettingsCached = (options?: { force?: boolean }): Promise<FlightProviderType[]> => {
    if (!options?.force) {
      if (this.allFlightProvidersCache) return Promise.resolve(this.allFlightProvidersCache);
      if (this.allFlightProvidersPromise) return this.allFlightProvidersPromise;
    }

    this.allFlightProvidersPromise = this.getAllFlightProvidersSettings()
      .then((data) => {
        this.allFlightProvidersCache = data;
        return data;
      })
      .finally(() => {
        // Keep the cache, but allow retries if a forced refresh happens later.
        this.allFlightProvidersPromise = null;
      });

    return this.allFlightProvidersPromise;
  };

  public clearAllFlightProvidersSettingsCache = (): void => {
    this.allFlightProvidersCache = null;
    this.allFlightProvidersPromise = null;
  };

  public setAllowedFlightProviders = (params: AllowedFlightProvidersType): Promise<void> =>
    this.instance.put('update/allowedflightproviders', params);
}

export default new FlightProvidersService();
